module.exports = __webpack_public_path__ + "furniture.323a740e631967875536.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/furniture/webfont/furniture.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/furniture/webfont/furniture.woff
// module chunks = styles